import { IOpenedGroupIdSetAction } from './types';
import { AT_OPENED_GROUP_ID_SET } from './constants';
import { TChatGroupId } from '../../../../../../../types/rest/IRestChatGroup';

export const openedGroupIdSetAction = (
    id: TChatGroupId,
): IOpenedGroupIdSetAction => ({
    type: AT_OPENED_GROUP_ID_SET,
    id,
});
